import { collection, query, getDocs, getFirestore } from 'firebase/firestore';
import DbCollections from '../../../resources/enums/DbCollections';
import { Language } from '../types';

export const getLanguagesFirebase = async () => {
    const querySnapshot = await getDocs(query(collection(getFirestore(), DbCollections.Languages)));
    const languages = [] as Language[];
    querySnapshot.forEach((doc) => {
        languages.push({ code: doc.data().code, name: doc.data().name });
    });
    return languages;
};
